module.exports = __webpack_public_path__ + "img/et.etc3d2d75.svg";